class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.handleOverlayClick = this.close.bind(this);
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.handleOverlayClick);
    this.setHeaderCartIconAccessibility();

    const iconsearch = document.querySelector(".header__search");
    if (iconsearch)
      iconsearch.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    const iconaccount = document.querySelector(".header__icon--account");
    if (iconaccount)
      iconaccount.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    this.stickyHeaderAvailable = document.querySelector('sticky-header') ? true : false;
    this.isOpening = false;
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    // if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      // this.open(cartLink);
      this.classList.contains("active") ? this.close() : this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.stabilizeDrawerSurface();
    if (this.classList.contains('active') || this.isOpening) {
      document.body.classList.add('cart_active', 'overflow-hidden');
      document.documentElement.classList.add('cart-drawer-active');
      this.activateFocusTrap();
      return;
    }

    this.isOpening = true;
    requestAnimationFrame(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('cart_active', 'overflow-hidden');
      document.documentElement.classList.add('cart-drawer-active');
      this.isOpening = false;
    });

    this.addEventListener(
      'transitionend',
      () => {
        this.activateFocusTrap();
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('cart_active');
    document.documentElement.classList.remove('cart-drawer-active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.isOpening = false;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    requestAnimationFrame(() => {
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.handleOverlayClick);
      this.stabilizeDrawerSurface();
      if (this.classList.contains('active')) {
        document.body.classList.add('cart_active', 'overflow-hidden');
        document.documentElement.classList.add('cart-drawer-active');
        this.activateFocusTrap();
        return;
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  revealHeader() {
    const stickyHeader = document.querySelector('sticky-header');
    stickyHeader?.reveal?.();
    document.querySelectorAll('.section-header, .shopify-section-group-header-group').forEach((element) => {
      element.classList?.remove?.('shopify-section-header-hidden');
      element.classList?.add?.('shopify-section-header-sticky');
      if (element.style) {
        element.style.transform = 'translateY(0)';
        element.style.opacity = '1';
      }
    });
  }

  activateFocusTrap() {
    const containerToTrapFocusOn = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
    if (!containerToTrapFocusOn || !focusElement) return;
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  stabilizeDrawerSurface() {
    this.style.position = 'fixed';
    this.style.top = '0';
    this.style.right = '0';
    this.style.bottom = '0';
    this.style.left = '0';
    this.style.height = '100dvh';
    this.style.width = '100vw';
    const panel = this.querySelector('#CartDrawer');
    if (panel) {
      panel.style.marginTop = '0';
      panel.style.maxHeight = '100dvh';
      panel.style.height = '100dvh';
    }
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.style.position = 'fixed';
      overlay.style.top = '0';
      overlay.style.right = '0';
      overlay.style.bottom = '0';
      overlay.style.left = '0';
      overlay.style.height = '100dvh';
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
